import { arc as d3arc, pie as d3pie } from "d3-shape";
import type { CategoryData } from "../../../lib/categories";

/** The category pie, drawn with d3-shape into React-managed SVG (the old `Pie.hx`). */
export function Pie({
  categories,
  width,
  height,
  widthOffset = 0,
  heightOffset = 0,
  selectedIndex = null,
  onSelect,
  onDeselect,
}: {
  categories: CategoryData[];
  width: number;
  height: number;
  widthOffset?: number;
  heightOffset?: number;
  selectedIndex?: number | null;
  onSelect?: (index: number) => void;
  onDeselect?: () => void;
}) {
  const radius = Math.min(width, height) / 2;
  const layout = d3pie<CategoryData>().value((d) => (d.grams === 0 ? 1e-15 : d.grams)).sort(null);
  const arc = d3arc<ReturnType<typeof layout>[number]>().innerRadius(0).outerRadius(radius);
  const slices = layout(categories);
  return (
    <div className="Pie">
      <div className="pieHolder">
        <svg width={width + widthOffset * 2} height={height + heightOffset * 2} role="img" aria-label="Weight by category">
          <g transform={`translate(${width / 2 + widthOffset},${height / 2 + heightOffset})`}>
            <g className="slices" onMouseLeave={onDeselect}>
              {slices.map((s) => (
                <path
                  key={s.data.index}
                  className={`slice ${s.data.cssClass}`}
                  d={arc(s) ?? undefined}
                  style={{ stroke: "white", strokeOpacity: 0.2, transition: "transform .1s" }}
                  transform={selectedIndex === s.data.index ? "scale(1.2)" : "scale(1)"}
                  onMouseEnter={() => onSelect?.(s.data.index)}
                  onClick={() => onSelect?.(s.data.index)}
                />
              ))}
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}
